module.exports = __webpack_public_path__ + "files/47262ba994a9beb41919582a25cc992c.png";